import DraggableTable from '../utils/DraggableTable';
import Rails from '@rails/ujs';
import { getHtmlFromAjaxResponse } from '../utils/ajaxResponseHelpers';

export default class BackofficeWorkflowsShow extends DraggableTable {
  constructor() {
    super('draggable-tbody'); 
    this.bindEvents();
  }

  bindEvents() {
    $(".toggle-step").off('change', this.toggleStep).on('change', this.toggleStep);
    $("#bo-preview, #extranet-preview").on('click', this.loadPreview.bind(this));
    $("#team-select, #entity-select").on('change', this.loadPreview.bind(this));
    $("#bo-preview").trigger('click');
    this.initializeServiceNumberFormatEditor();
    this.initializeServiceDeadlineDisplay();
  }

  initializeServiceDeadlineDisplay() {
    const serviceSelect = document.getElementById('workflow_service_select');
    if (!serviceSelect) return;

    serviceSelect.addEventListener('change', (e) => {
      this.fetchServiceDeadlineDays(e.target.value);
    });
  }

  fetchServiceDeadlineDays(serviceId) {
    const deadlineDisplay = document.getElementById('service-deadline-display');
    const deadlineInput = document.getElementById('service-deadline-days');
    const baseUrl = document.getElementById('workflow_service_select').dataset.url;

    if (!serviceId || !baseUrl) {
      if (deadlineDisplay) deadlineDisplay.style.display = 'none';
      return;
    }

    const url = baseUrl + '?service_id=' + serviceId;

    Rails.ajax({
      url: url,
      type: 'GET',
      success: (data) => {
        if (deadlineDisplay) deadlineDisplay.style.display = 'block';
        if (deadlineInput) deadlineInput.value = data.deadline_days_hr;
        this.checkDeadlineMismatch(data.deadline_days);
      },
      error: () => {
        if (deadlineDisplay) deadlineDisplay.style.display = 'none';
        this.showError("Erreur lors de la récupération du délai de déploiement");
      }
    });
  }

  checkDeadlineMismatch(serviceDeadlineDays) {
    const warningElement = document.getElementById('deadline-mismatch-warning');
    const contractualDuration = Number.parseInt(document.getElementById('workflow-contractual-duration')?.dataset?.days || 0);

    if (warningElement && serviceDeadlineDays > 0 && contractualDuration > 0) {
      if (serviceDeadlineDays !== contractualDuration) {
        warningElement.style.display = 'block';
      } else {
        warningElement.style.display = 'none';
      }
    }
  }

  updateOrder() {
    const rows = document.querySelectorAll(`#${this.tableId} tr`);
    const ids = Array.from(rows).map(row => row.dataset.id);
    const url = document.getElementById('draggable-tbody').dataset.url;

    this.rearrangeRowsOrder(ids);

    const params = new URLSearchParams();
    ids.forEach(id => params.append('steps_ids[]', id));

    Rails.ajax({
      url: url,
      type: 'PUT',
      data: params.toString(),
      success: (data) => this.handleOrderUpdateSuccess(data),
      error: () => this.showError("backoffice.workflows.update.error"),
    });
  }

  handleOrderUpdateSuccess(data) {
    const warning = document.getElementById('order-warning');
    if (warning) {
      data.valid_order ? warning.classList.add('d-none') : warning.classList.remove('d-none');
    }
  }

  rearrangeRowsOrder(ids) {
    document.querySelectorAll(`#${this.tableId} tr`).forEach((row, index) => {
      const cell = row.querySelector('td:nth-child(2)');
      if (cell) cell.textContent = index + 1;
    });
  }

  toggleStep(e) {
    const { dataset: { url }, checked } = e.target;

    Rails.ajax({
      url: url,
      type: 'PUT',
      data: new URLSearchParams({ active: checked }).toString(),
      success: () => this.showSuccess("Étape mise à jour avec succès"),
      error: () => this.showError("Erreur lors de la mise à jour de l'étape"),
    });
  }

  initializeServiceNumberFormatEditor() {
    const canAddComponent = () => $('#draggable-tbody-modal tr').length < 6;

    const createComponentRow = (type, placeholder = '', value = '', readonly = false) => $(`
      <tr draggable="true" class="border-bottom component ${type === 'date' ? 'date-field' : ''}">
        <td class="py-2"><i class="fas fa-grip-lines"></i></td>
        <td class="py-2">${type === 'string' ? 'Chaîne de caractères' : 'Date'}</td>
        <td class="py-2 text-left">
          <input type="text" class="form-control component" 
                 placeholder="${placeholder}" value="${value}" ${readonly ? 'readonly' : ''}>
          <button class="btn btn-danger ml-2 remove-component" type="button">
            <i class="fas fa-trash-alt"></i>
          </button>
        </td>
      </tr>
    `);

    const addComponent = (type) => {
      const tbody = $('#draggable-tbody-modal');
      if (type === 'string') {
        tbody.prepend(createComponentRow('string', 'Entrer une valeur'));
      } else if (type === 'date' && $('#draggable-tbody-modal #date-field').length === 0) {
        tbody.prepend(createComponentRow('date', '', 'DDMMYYYY', true));
        $('.add_date').prop('disabled', true);
      }

      $('.remove-component').off('click').on('click', function() {
        let isDateField = $(this).closest('tr').hasClass('date-field');
        
        if (isDateField) {
          $('.add_date').prop('disabled', false);
        }

        $(this).closest('tr').remove();
      });
    };

    $('.add_string').click(() => canAddComponent() && addComponent('string'));
    $('.add_date').click(() => canAddComponent() && addComponent('date'));
    $('.clear-format').click(this.clearFormat);

    $('.service-number-format-btn').click(this.saveServiceNumberFormat);
  }

  clearFormat() {
    $('#draggable-tbody-modal').children().not('#numerotation').remove();
    $('.add_date').prop('disabled', false);
  }

  saveServiceNumberFormat() {

    function showAlert(message) {
      document.getElementById('alert-container').innerHTML = `
        <div class="alert alert-danger alert-dismissible fade show" role="alert">
          ${message}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      `;
    }
  
    const url = document.getElementById('service-number-format').dataset.url;
    const componentInputs = document.querySelectorAll('#format-container .component');
    const components = Array.from(componentInputs)
      .map(el => el.value.trim())
      .filter(Boolean);
  
    if (components.length < 2) {
      showAlert("Le format doit inclure au moins 2 composants.");
      return;
    }
  
    const specialCharPattern = /[^a-zA-Z0-9]/;
    if (components.some(component => specialCharPattern.test(component))) {
      showAlert("Les composants ne doivent pas contenir de caractères spéciaux.");
      return;
    }
  
    const format = components.join('-');
    const startNumber = document.getElementById('start_number').value;
    Rails.ajax({
      url: url,
      type: 'PUT',
      data: new URLSearchParams({ format: format, start_number: startNumber }).toString(),
    });
  }

  loadPreview(e) {
    e.preventDefault();
    const target = e.target;
    const url = target.dataset.url;
    const isBO = target.dataset.type === 'backoffice';

    this.togglePreviewTabs(isBO);

    const teamSelect = document.getElementById('team-select');
    const entitySelect = document.getElementById('entity-select');
    const data = isBO
      ? { team_id: teamSelect ? teamSelect.value : '' }
      : { entity_id: entitySelect ? entitySelect.value : '' };

    Rails.ajax({
      url: url,
      type: 'GET',
      data: new URLSearchParams(data).toString(),
      success: (responseData, _status, xhr) => {
        const previewContent = document.getElementById('preview-content');
        if (previewContent) previewContent.innerHTML = getHtmlFromAjaxResponse(responseData, xhr);
      },
      error: () => this.showError("Erreur lors du chargement de l'aperçu"),
    });
  }

  togglePreviewTabs(isBO) {
    const boPreview = document.getElementById('bo-preview');
    const extranetPreview = document.getElementById('extranet-preview');
    const teamsWrapper = document.getElementById('teams-select-wrapper');
    const entitiesWrapper = document.getElementById('entities-select-wrapper');

    if (boPreview) boPreview.classList.toggle('underline', isBO);
    if (extranetPreview) extranetPreview.classList.toggle('underline', !isBO);
    if (teamsWrapper) teamsWrapper.style.display = isBO ? 'block' : 'none';
    if (entitiesWrapper) entitiesWrapper.style.display = isBO ? 'none' : 'block';
  }

  showSuccess(message) {
    application.successNotification(message);
  }

  showError(message) {
    application.errorNotification(I18n.t(message));
  }

  onDataChanged(data) {}
  onDestroy() {}
}